module.exports = __webpack_public_path__ + "media/images/logo-45a77ab15358d5d56a81264247422ce1.svg";